document.addEventListener('DOMContentLoaded', function() {
    
    function initCalendar() {
        const widgets = document.querySelectorAll('.calendar-booking-widget');
        
        // Find the widget that's actually visible and has the right structure
        let widget = null;
        for (let w of widgets) {
            const monthYear = w.querySelector('.calendar-month-year');
            const datesContainer = w.querySelector('.calendar-dates');
            if (monthYear && datesContainer && w.offsetParent !== null) {
                widget = w;
                break;
            }
        }
        
        if (!widget) {
            setTimeout(initCalendar, 500);
            return;
        }

        const monthYear = widget.querySelector('.calendar-month-year');
        const datesContainer = widget.querySelector('.calendar-dates');
        const timeSlotsSection = widget.querySelector('.time-slots');
        const appointmentList = widget.querySelector('.appointment-list');
        const prevBtn = widget.querySelector('.calendar-nav.prev');
        const nextBtn = widget.querySelector('.calendar-nav.next');
        
        if (!monthYear || !datesContainer) {
            return;
        }
        
        // Mark this widget as initialized to prevent conflicts
        if (widget.dataset.initialized) {
            return;
        }
        widget.dataset.initialized = 'true';

        let currentDate = new Date();
        let selectedDate = null;
        const formFields = ['input_4_27', 'input_4_29', 'input_4_30'];
        const holidays = ['2026-01-01', '2026-01-19', '2026-02-16', '2026-05-25', '2026-06-19', '2026-07-03', '2026-09-07', '2026-11-11', '2026-11-26', '2026-12-24', '2026-12-25', '2027-01-01', '2027-01-18', '2027-02-15', '2027-05-31', '2027-06-19', '2027-07-05', '2027-09-06', '2027-11-11', '2027-11-25', '2027-12-24', '2027-12-25', '2028-01-01', '2028-01-17', '2028-02-21', '2028-05-29', '2028-06-19', '2028-07-04', '2028-09-04', '2028-11-10', '2028-11-23', '2028-12-24', '2028-12-31'];

        function isWeekend(date) {
            return date.getDay() === 0 || date.getDay() === 6;
        }

        function isHoliday(date) {
            const dateStr = date.toISOString().split('T')[0];
            return holidays.includes(dateStr);
        }

        function isPastDate(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date < today;
        }

        function isDateAvailable(date) {
            return !isWeekend(date) && !isHoliday(date) && !isPastDate(date);
        }

        function renderCalendar() {
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth();
            
            monthYear.textContent = new Date(year, month).toLocaleDateString('en-US', { 
                month: 'long', 
                year: 'numeric' 
            });

            const firstDay = new Date(year, month, 1);
            const startDate = new Date(firstDay);
            startDate.setDate(startDate.getDate() - firstDay.getDay());

            datesContainer.innerHTML = '';

            for (let i = 0; i < 42; i++) {
                const date = new Date(startDate);
                date.setDate(startDate.getDate() + i);
                
                const dateDiv = document.createElement('div');
                dateDiv.className = 'calendar-date';
                dateDiv.textContent = date.getDate();
                
                if (date.getMonth() !== month) {
                    dateDiv.style.opacity = '0.3';
                } else if (!isDateAvailable(date)) {
                    dateDiv.classList.add('_unavailable');
                    dateDiv.style.cursor = 'not-allowed';
                } else {
                    dateDiv.addEventListener('click', () => selectDate(date));
                }
                
                datesContainer.appendChild(dateDiv);
            }
        }

        function selectDate(date) {
            selectedDate = date;
            
            // Remove any existing inline time slots
            const existingTimeSlots = datesContainer.querySelector('.inline-time-slots');
            if (existingTimeSlots) {
                existingTimeSlots.remove();
            }
            
            // Highlight selected date
            document.querySelectorAll('.calendar-date').forEach(d => d.classList.remove('selected'));
            event.target.classList.add('selected');
            
            // Find which row the selected date is in
            const dateIndex = Array.from(datesContainer.children).indexOf(event.target);
            const rowEndIndex = Math.floor(dateIndex / 7) * 7 + 6;
            
            // Create inline time slots
            const inlineTimeSlots = document.createElement('div');
            inlineTimeSlots.className = 'inline-time-slots';
            inlineTimeSlots.style.gridColumn = '1 / -1';
            inlineTimeSlots.innerHTML = `
                <div class="time-options">
                    <button type="button" class="time-slot" data-time="09:00">9 AM</button>
                    <button type="button" class="time-slot" data-time="10:00">10 AM</button>
                    <button type="button" class="time-slot" data-time="13:00">1 PM</button>
                    <button type="button" class="time-slot" data-time="15:00">3 PM</button>
                </div>
            `;
            
            // Insert after the row
            const rowEndElement = datesContainer.children[rowEndIndex];
            if (rowEndElement) {
                rowEndElement.insertAdjacentElement('afterend', inlineTimeSlots);
            }
            
            // Add event listeners to new time slot buttons
            inlineTimeSlots.querySelectorAll('.time-slot').forEach(btn => {
                btn.addEventListener('click', () => selectTime(btn.dataset.time));
            });
            
            // Hide the original time slots section
            if (timeSlotsSection) {
                timeSlotsSection.style.display = 'none';
            }
        }

        let currentFieldIndex = 0;

        function getNextField() {
            const field = document.getElementById(formFields[currentFieldIndex]);
            currentFieldIndex = (currentFieldIndex + 1) % formFields.length;
            return field;
        }

        function selectTime(time) {
            if (!selectedDate) return;
            
            const field = getNextField();
            if (!field) return;

            const dateStr = selectedDate.toLocaleDateString('en-US');
            const timeStr = time === '09:00' ? '9 AM' : 
                        time === '10:00' ? '10 AM' : 
                        time === '13:00' ? '1 PM' : '3 PM';
            
            field.value = `${dateStr} at ${timeStr}`;
            updateAppointmentList();
            
            // Remove inline time slots
            const inlineTimeSlots = datesContainer.querySelector('.inline-time-slots');
            if (inlineTimeSlots) {
                inlineTimeSlots.remove();
            }
            
            selectedDate = null;
            
            // Remove selection highlight
            document.querySelectorAll('.calendar-date').forEach(d => d.classList.remove('selected'));
        }

        function updateAppointmentList() {
            if (!appointmentList) return;
            
            const appointments = formFields.map(id => {
                const field = document.getElementById(id);
                return field ? field.value : '';
            }).filter(val => val);

            appointmentList.innerHTML = appointments.map(apt => 
                `<div class="appointment-item">${apt}</div>`
            ).join('');
        }

        // Event listeners
        if (prevBtn) {
            prevBtn.addEventListener('click', () => {
                currentDate.setMonth(currentDate.getMonth() - 1);
                renderCalendar();
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                currentDate.setMonth(currentDate.getMonth() + 1);
                renderCalendar();
            });
        }

        widget.querySelectorAll('.time-slot').forEach(btn => {
            btn.addEventListener('click', () => selectTime(btn.dataset.time));
        });
        
        // Listen for Gravity Forms previous button clicks
        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('gform_previous_button')) {
                setTimeout(() => {
                    // Re-initialize the entire calendar
                    initCalendar();
                }, 500);
            }
        });

        // Initialize
        renderCalendar();
        updateAppointmentList();
        
        // Re-render after a delay to handle interference
        setTimeout(() => {
            if (datesContainer.children.length === 0) {
                renderCalendar();
            }
        }, 100);
    }
    
    initCalendar();
});